import React from 'react';
import { Collapse, List } from 'antd-mobile';
import { OSS_PREFIX } from '../../oss.config';
import { title } from 'process';

const FeatureQuickCheck = () => {
  const componentSpecs = [
    { part: '小可豆', desc: '每个小可豆有独特性格，孩子与它们的互动中，能潜移默化学习它们的优秀品质。比如：小熊卡卡可以激发孩子好奇心，培养探索精神；小兔子罗西可以激发孩子的爱心和责任心，学会理解和关心他人的感受。' },
    { part: '电源键', desc: '开机：长按3秒开机；关机：长按5秒关机；打断：与角色对话过程中，短按可以打断对话并回待机状态（此时可清晰说出“可豆贝贝”唤醒，开始对话）。' },
    { part: '音量键', desc: '增加音量：按“+”键；降低音量：按“-”键；配网模式：同时按住音量+、-键。' },
    { part: '卡片感应区', desc: '将NFC互动游戏卡中部触碰该区域，即可开始对应的互动玩法。' },
    { part: '显示屏', desc: '显示毛绒角色表情和交互信息，亮起表示开机。' },
    { part: '指示灯', desc: '充电时指示灯闪烁，充满电后指示灯常亮。' },
    { part: '充电口', desc: '使用符合规定的Type-C充电线插入充电口，接通电源即可充电。' },
    { part: '绑带', desc: '小可豆佩戴超能眼镜：将眼镜绑带穿过小可豆头部两侧的小孔，在后脑处将卡扣扣住。' },
    { part: '豆芽仓', desc: '将小可豆的NFC小豆芽插入豆芽仓，系统识别小可豆身份后与孩子进行互动。' },
    { part: '麦克风', desc: '设备通过麦克风接收孩子说话声音。' },
  ];

  const features = [
    {
      title: '配置网络',
      content: <>
        <List mode="card">
          <List.Item className='wifi-card-tip'>1. 首次使用时配置网络</List.Item>
          <p>进入kidopally小程序，点击下图位置，创建孩子后根据指引进行首次配网。</p>
          <List.Item><img className='kidopally-image step-image' src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/loading_page_guide.png`}></img></List.Item>
          <List.Item className='wifi-card-tip'>2. 重新配网或增加新网络</List.Item>
          <p>若小程序已经有孩子信息，进入小程序首页，点击孩子名称右侧“配置网络”进入配网。</p>
          <List.Item><img className='kidopally-image step-image' src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/wifi-entrance-guide.png`}></img></List.Item>
          <p>若家人或亲友配置网络，建议邀请TA加入亲友团后在小程序首页配置网络。若还没有加入亲友团，也可以进入小程序后，点击下图进入配网。</p>
          <List.Item><img className='kidopally-image step-image' src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/wifi-used-guide.png`}></img></List.Item>
          <List.Item>
            <p className='warning-tip' > ⚠️ 注意事项：<br/> ① WiFi仅支持2.4G频段，5G频段无法使用。<br/> ② 若家里WiFi是5G频段，请把WiFi路由器设置为2.4G或双频合一模式。<br/> ③ 若使用手机热点，注意设置为2.4G频段。华为设备在“个人热点”设置界面中，找到“更多共享设置”或“显示高级选项”，即可设置。IOS设备在“个人热点”设置界面中，找到 “最大兼容性” 选项，将其开关打开，即可设置为 2.4GHz 频段。其它设备可在系统搜索“热点”关键词进入相应的界面进行设置。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '开始语音对话',
      content: <>
        <div>
        <List.Item>开机后，当屏幕上显示出眼睛时，表示设备已经准备好，此时清晰说出“可豆贝贝”，即可开始对话。</List.Item>
        <List.Item>
            <p className='warning-tip' > ⚠️ 注意事项：<br/> 确保环境安静，语音清晰。如果环境嘈杂，会降低语音识别的正确率。</p>
          </List.Item>
        </div>
      </>
    },
    {
      title: '打断对话',
      content: <>
        <List mode="card">
          <List.Item>方式一：按键打断。对话过程中，短按电源键，打断当前对话。此时，说出“可豆贝贝”可重新开始对话。</List.Item>
          <List.Item>方式二：语音打断。对话过程中，说出“可豆贝贝”，打断当前对话。此时，可以直接开始新对话。</List.Item>
        </List>
      </>
    },
    {
      title: '结束对话',
      content: <>
        <List mode="card">
          <List.Item>短按电源键，可结束对话。此时，说出“可豆贝贝”可重新开始对话。</List.Item>
        </List>
      </>
    },
    {
      title: '充电',
      content: <>
        <List mode="card">
          <List.Item>插入符合要求的Type-C充电线，接通电源即进入充电状态。指示灯闪烁表示正在充电，指示灯长亮表示已充满电。</List.Item>
          <List.Item>
          <p className='warning-tip' > ⚠️ 注意事项：<br/> Type-C充电线规格要求 5V,1A，请选择正规厂商的合格产品使用。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '使用卡片',
      content: <>
        <List mode="card">
          <List.Item>当屏幕显示出眼睛表情时，将卡片贴近眼镜右侧感应区停留片刻，听到音效，表示卡片已识别。</List.Item>
          <List.Item><img className='kidopally-image step-image' src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/card_guide.png`}></img></List.Item>
          <List.Item>
            <p className='warning-tip' > ⚠️ 注意事项：<br/> 为提高卡牌识别准确度，请将卡片中心位置紧贴感应区。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '音量调节',
      content: <>
        <List mode="card">
          <List.Item>短按音量+、-键即可增加或减少音量。</List.Item>
          <List.Item>
            <p className='warning-tip'> ⚠️ 注意事项：<br/> 若按太快，可能无法调节，请按下音量键稍微停留片刻。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '开关机',
      content: <>
        <List mode="card">
          <List.Item>开机：按住电源键3秒，直到屏幕亮起。</List.Item>
          <List.Item>关机：按住电源键5秒，直到屏幕关闭。</List.Item>
        </List>
      </>
    },
    {
      title: '结束游戏',
      content: <>
        <List mode="card">
          <List.Item>在游戏中时，对玩具说出“结束游戏”，可以离开当前游戏，回到正常对话。</List.Item>
        </List>
      </>
    },
    {
      title: '邀请亲友',
      content: <>
        <List mode="card">
          <List.Item>进入小程序 &gt; 点击孩子头像 &gt; 点击孩子管理 &gt; 选择孩子 &gt; 找到“Ta的亲友”，点击“邀请亲友”。</List.Item>
        </List>
      </>
    },
    {
      title: '摇一摇',
      content: <>
        <List mode="card">
          <List.Item>摇一摇会出现有趣的表情和音效，给孩子带来欢乐。使用时，先短按电源键确保回到摇一摇模式，此时前后左右任意方向来回摇动即可。</List.Item>
          <List.Item>
            <p className='warning-tip' > ⚠️ 注意事项：<br/> ① 眼镜开机准备过程中，或者其它在异常状态（网络异常、没有插入角色小豆芽等）无法使用<br/> ② 小可豆在倾听和讲话时不能使用，此时短按电源键可进入摇一摇模式。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '系统升级',
      content: <>
        <List mode="card">
          <List.Item>当有更高级版本，且设备处于联网状态，系统会自动升级，升级时，屏幕显示下图动画。</List.Item>
          <List.Item><img className='kidopally-image step-image' src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/ota_guide.png`}></img></List.Item>
          <List.Item>
            <p className='warning-tip' > ⚠️ 注意事项：<br/> 升级所需时长与新版本变化大小和网速相关，最长会有十几分钟，请耐心等待哦。</p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '部件功能速查',
      content: <>
        <List mode="card">
        <div className="specs-table">
                <div className="table-header">
                  <div className="table-cell">部件</div>
                  <div className="table-cell">功能说明</div>
                </div>
                {componentSpecs.map((spec, index) => (
                  <div key={index} className="table-row">
                    <div className="table-cell">{spec.part}</div>
                    <div className="table-cell">{spec.desc}</div>
                  </div>
                ))}
          </div>
        </List>
      </>
    },
    {
      title: '多设备使用问题',
      content: <>
        <List mode="card">
          <List.Item>一个孩子同时只能绑定一个设备。若你拥有多个设备（通常是多个孩子分别使用），注意绑定或配网时先选择正确的孩子，再进行操作。以避免孩子原来绑定的设备被自动解绑</List.Item>
          <List.Item>若某个孩子已经绑定了一个设备，再用其它设备进行绑定或配置网络，原设备会自动解绑为不可用（此时重新进行配网即可再次绑定）</List.Item>
        </List>
      </>
    }
  ];

  return (
    <Collapse accordion>
      {features.map((item, index) => (
        <Collapse.Panel key={index.toString()} title={item.title}>
          {item.content}
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};

export default FeatureQuickCheck;